export default __webpack_public_path__ + "static/media/Gimtonico.1d65bcd6.mp4";